<div class="excavation-details" *ngIf="selectedExcavation">
  <div class="main-content-container">
    <!-- All Details Sections -->
    <div class="details-wrapper flex flex-column">
      <!-- Top Information Section -->
      <div class="top-info-section" *ngIf="selectedExcavation.responsibleForObligationsHeb || selectedExcavation.excavationTypeName" [ngClass]="{'has-map-icon': selectedExcavation.mapInfo?.excavationPolygon, 'en': currentLang === 'en', 'he': currentLang === 'he'}">
        <div class="info-content">
          <div class="info-row" *ngIf="selectedExcavation.responsibleForObligationsHeb">
            <span class="info-label">{{ 'iaa.app.excavation.responsibleForObligations' | translate }}:</span>
            <span class="info-value">
              <span 
                class="responsible-link"
                role="button"
                tabindex="0"
                [attr.aria-label]="'View excavations by ' + (currentLang === 'he' ? selectedExcavation.responsibleForObligationsHeb : selectedExcavation.responsibleForObligationsEng)"
                (click)="handleResponsiblePersonClick()"
                (keydown.enter)="handleResponsiblePersonClick()"
                (keydown.space)="handleResponsiblePersonClick(); $event.preventDefault()">
                {{ currentLang === 'he' ? selectedExcavation.responsibleForObligationsHeb : selectedExcavation.responsibleForObligationsEng }}
              </span>
            </span>
          </div>
          <div class="info-row" *ngIf="selectedExcavation.excavationTypeName">
            <span class="info-label">{{ 'iaa.app.excavation.excavationType' | translate }}:</span>
            <span class="info-value">
              {{ selectedExcavation.excavationTypeName }}<span *ngIf="selectedExcavation.excavationSubtypeName"> - {{ selectedExcavation.excavationSubtypeName }}</span>
            </span>
          </div>
        </div>
        <div class="excavation-map-icon" *ngIf="selectedExcavation.mapInfo?.excavationPolygon">
          <i class="pi pi-map-marker action-icon" 
             [ngClass]="{'active': selectedExcavation.entityId === selectedEntityId}"
             role="button"
             tabindex="0"
             [attr.aria-label]="'iaa.app.excavation.showExcavationOnMap' | translate"
             (click)="onMapIconClick(selectedExcavation.entityId, 'excavation', $event)"
             (keydown.enter)="onMapIconClick(selectedExcavation.entityId, 'excavation', $event)"
             (keydown.space)="onMapIconClick(selectedExcavation.entityId, 'excavation', $event); $event.preventDefault()"
             title="{{ 'iaa.app.excavation.showExcavationOnMap' | translate }}"></i>
        </div>
      </div>

      <!-- Licenses Section -->
      <details [open]="true" *ngIf="selectedExcavation.licenses && selectedExcavation.licenses.length > 0">
        <summary
          [attr.aria-label]="('iaa.app.excavation.licenses' | translate) + ' (' + selectedExcavation.licenses.length + ')'">
          <div class="button">
            <div>{{ 'iaa.app.excavation.licenses' | translate }} ({{ selectedExcavation.licenses.length }})</div>
            <div class="icons">
              <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }" aria-hidden="true"></i>
              <i class="pi pi-angle-down icon-clicked" aria-hidden="true"></i>
            </div>
          </div>
        </summary>

        <!-- Unauthorized Content Warning -->
        <div *ngIf="hasUnauthorizedContentForType('licenses')"
          role="alert"
          [ngClass]="{'unauthorized':true,'en': currentLang === 'en','he': currentLang === 'he'}">
          <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="" role="presentation">
          <div
            [ngClass]="{'unauthorized-text':true,'en': currentLang === 'en','he': currentLang === 'he'}">
            {{ 'iaa.app.results.licensesNotDisplayed' | translate:
            {numberOfAllEntitiesUnauthorized: getUnauthorizedCountForType('licenses')} }}
            <button class="unauthorized-link" 
              (click)="handleOpenDialog()"
              (keydown.enter)="handleOpenDialog()" 
              (keydown.space)="handleOpenDialog(); $event.preventDefault()"
              tabindex="0"
              [attr.aria-label]="'iaa.app.results.viewListLicenses' | translate">
              <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
            </button>
          </div>
        </div>

        <div class="table-container" role="table" [attr.aria-label]="'iaa.app.excavation.licenses' | translate">
          <div class="table-row header" role="row">
            <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.licenseNumber' | translate }}</div>
            <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.excavators' | translate }}</div>
            <div class="table-cell" aria-hidden="true"></div>
          </div>
          <div *ngFor="let license of selectedExcavation.licenses" class="table-row" role="row">
            <div class="table-cell" role="cell"><bdi>{{ license.licenseLongName }}</bdi></div>
            <div class="table-cell" role="cell">
              <span *ngFor="let excavatorGroup of license.excavatorGroups; let isLast = last">
                <span *ngFor="let excavator of excavatorGroup.excavators; let isLastExcavator = last">
                  <span 
                    class="excavator-link"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="'View excavations by ' + getPersonName(excavator)"
                    (click)="handleExcavatorClick(excavator)"
                    (keydown.enter)="handleExcavatorClick(excavator)"
                    (keydown.space)="handleExcavatorClick(excavator); $event.preventDefault()">
                    {{ getPersonName(excavator) }}
                  </span><span *ngIf="!isLastExcavator">, </span>
                </span>
                <span *ngIf="excavatorGroup.excavators.length > 0" class="institution-name"> ({{ getExcavatorName(excavatorGroup) }})</span><span *ngIf="!isLast">; </span>
              </span>
            </div>
            <div class="table-cell" aria-hidden="true">
              <div class="icon-container">
                <i class="pi pi-map-marker action-icon" 
                   [ngClass]="{'active': license.licenseId === selectedEntityId}"
                   *ngIf="license.shapes && license.shapes.length > 0"
                   role="button"
                   tabindex="0"
                   [attr.aria-label]="'iaa.app.excavation.showOnMap' | translate"
                   (click)="onMapIconClick(license.licenseId, 'license', $event)"
                   (keydown.enter)="onMapIconClick(license.licenseId, 'license', $event)"
                   (keydown.space)="onMapIconClick(license.licenseId, 'license', $event); $event.preventDefault()"
                   title="{{ 'iaa.app.excavation.showOnMap' | translate }}"></i>
              </div>
            </div>
          </div>
        </div>
      </details>

      <!-- Publications Section -->
      <details [open]="selectedExcavation.publications.length === 1" *ngIf="selectedExcavation.publications && selectedExcavation.publications.length > 0">
    <summary
      [attr.aria-label]="('iaa.app.excavation.publications' | translate) + ' (' + selectedExcavation.publications.length + ')'">
      <div class="button">
        <div>{{ 'iaa.app.excavation.publications' | translate }} ({{ selectedExcavation.publications.length }})</div>
        <div class="icons">
          <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }" aria-hidden="true"></i>
          <i class="pi pi-angle-down icon-clicked" aria-hidden="true"></i>
        </div>
      </div>
    </summary>

    <!-- Unauthorized Content Warning -->
    <div *ngIf="hasUnauthorizedContentForType('publications')"
      role="alert"
      [ngClass]="{'unauthorized':true,'en': currentLang === 'en','he': currentLang === 'he'}">
      <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="" role="presentation">
      <div
        [ngClass]="{'unauthorized-text':true,'en': currentLang === 'en','he': currentLang === 'he'}">
        {{ 'iaa.app.results.licensesNotDisplayed' | translate:
        {numberOfAllEntitiesUnauthorized: getUnauthorizedCountForType('publications')} }}
        <button class="unauthorized-link" 
          (click)="handleOpenDialog()"
          (keydown.enter)="handleOpenDialog()" 
          (keydown.space)="handleOpenDialog(); $event.preventDefault()"
          tabindex="0"
          [attr.aria-label]="'iaa.app.results.viewListLicenses' | translate">
          <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
        </button>
      </div>
    </div>

    <div class="table-container publications-table" role="table" [attr.aria-label]="'iaa.app.excavation.publications' | translate">
      <div class="table-row header" role="row">
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.publicationName' | translate }}</div>
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.description' | translate }}</div>
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.licenseNumber' | translate }}</div>
        <div class="table-cell" aria-hidden="true"></div>
      </div>
      <div *ngFor="let publication of selectedExcavation.publications" class="table-row" role="row">
        <div class="table-cell" role="cell">
          <span class="link-note" 
            *ngIf="publication.viewUrl" 
            (click)="openUrl(publication.viewUrl)" 
            (keydown.enter)="openUrl(publication.viewUrl)" 
            (keydown.space)="openUrl(publication.viewUrl); $event.preventDefault()"
            tabindex="0" 
            role="button"
            [attr.aria-label]="'View ' + ((publication.title || {hebrew: '', english: ''}) | translateLang | async)">
            {{ (publication.title || {hebrew: '', english: ''}) | translateLang | async }}
          </span>
          <span *ngIf="!publication.viewUrl">{{ (publication.title || {hebrew: '', english: ''}) | translateLang | async }}</span>
        </div>
        <div class="table-cell" role="cell">
          <span>{{ (publication.description || {hebrew: '', english: ''}) | translateLang | async }}</span>
        </div>
        <div class="table-cell" role="cell">{{ publication.licenseNumber }}</div>
        <div class="table-cell" aria-hidden="true">
          <div class="icon-container">
            <i class="pi pi-eye action-icon" 
               *ngIf="publication.viewUrl"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.view' | translate"
               (click)="openUrl(publication.viewUrl)"
               (keydown.enter)="openUrl(publication.viewUrl)"
               (keydown.space)="openUrl(publication.viewUrl); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.view' | translate }}"></i>
            <i class="pi pi-map-marker action-icon" 
               [ngClass]="{'active': publication.entityId === selectedEntityId}"
               *ngIf="publication.shapes && publication.shapes.length > 0"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.showOnMap' | translate"
               (click)="onMapIconClick(publication.entityId, 'publication', $event)"
               (keydown.enter)="onMapIconClick(publication.entityId, 'publication', $event)"
               (keydown.space)="onMapIconClick(publication.entityId, 'publication', $event); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.showOnMap' | translate }}"></i>
          </div>
        </div>
      </div>
    </div>
  </details>

  <!-- Excavation Files Section -->
  <details [open]="selectedExcavation.excavationFiles.length === 1" *ngIf="selectedExcavation.excavationFiles && selectedExcavation.excavationFiles.length > 0">
    <summary
      [attr.aria-label]="('iaa.app.excavation.danaPdfs' | translate) + ' (' + selectedExcavation.excavationFiles.length + ')'">
      <div class="button">
        <div>{{ 'iaa.app.excavation.danaPdfs' | translate }} ({{ selectedExcavation.excavationFiles.length }})</div>
        <div class="icons">
          <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }" aria-hidden="true"></i>
          <i class="pi pi-angle-down icon-clicked" aria-hidden="true"></i>
        </div>
      </div>
    </summary>

    <!-- Unauthorized Content Warning -->
    <div *ngIf="hasUnauthorizedContentForType('files')"
      role="alert"
      [ngClass]="{'unauthorized':true,'en': currentLang === 'en','he': currentLang === 'he'}">
      <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="" role="presentation">
      <div
        [ngClass]="{'unauthorized-text':true,'en': currentLang === 'en','he': currentLang === 'he'}">
        {{ 'iaa.app.results.licensesNotDisplayed' | translate:
        {numberOfAllEntitiesUnauthorized: getUnauthorizedCountForType('files')} }}
        <button class="unauthorized-link" 
          (click)="handleOpenDialog()"
          (keydown.enter)="handleOpenDialog()" 
          (keydown.space)="handleOpenDialog(); $event.preventDefault()"
          tabindex="0"
          [attr.aria-label]="'iaa.app.results.viewListLicenses' | translate">
          <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
        </button>
      </div>
    </div>

    <div class="table-container" role="table" [attr.aria-label]="'iaa.app.excavation.danaPdfs' | translate">
      <div class="table-row header" role="row">
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.danaPdfFile' | translate }}</div>
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.licenseNumber' | translate }}</div>
        <div class="table-cell" aria-hidden="true"></div>
      </div>
      <div *ngFor="let file of selectedExcavation.excavationFiles" class="table-row" role="row">
        <div class="table-cell" role="cell">
          <span class="link-note" 
            *ngIf="file.viewUrl" 
            (click)="openUrl(file.viewUrl)" 
            (keydown.enter)="openUrl(file.viewUrl)" 
            (keydown.space)="openUrl(file.viewUrl); $event.preventDefault()"
            tabindex="0" 
            role="button"
            [attr.aria-label]="'View ' + ((file.fileName || {hebrew: '', english: ''}) | translateLang | async)">
            {{ (file.fileName || {hebrew: '', english: ''}) | translateLang | async }}
          </span>
          <span *ngIf="!file.viewUrl">{{ (file.fileName || {hebrew: '', english: ''}) | translateLang | async }}</span>
        </div>
        <div class="table-cell" role="cell">{{ file.licenseNumber }}</div>
        <div class="table-cell" aria-hidden="true">
          <div class="icon-container">
            <i class="pi pi-eye action-icon" 
               *ngIf="file.viewUrl || file.downloadUrl"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.view' | translate"
               (click)="openUrl(file.viewUrl || file.downloadUrl)"
               (keydown.enter)="openUrl(file.viewUrl || file.downloadUrl)"
               (keydown.space)="openUrl(file.viewUrl || file.downloadUrl); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.view' | translate }}"></i>
            <i class="pi pi-map-marker action-icon" 
               [ngClass]="{'active': file.entityId === selectedEntityId}"
               *ngIf="file.shapes && file.shapes.length > 0"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.showOnMap' | translate"
               (click)="onMapIconClick(file.entityId, 'file', $event)"
               (keydown.enter)="onMapIconClick(file.entityId, 'file', $event)"
               (keydown.space)="onMapIconClick(file.entityId, 'file', $event); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.showOnMap' | translate }}"></i>
          </div>
        </div>
      </div>
    </div>
  </details>

  <!-- 3D Models Section -->
  <details [open]="selectedExcavation.models.length === 1" *ngIf="selectedExcavation.models && selectedExcavation.models.length > 0">
    <summary
      [attr.aria-label]="('iaa.app.excavation.models' | translate) + ' (' + selectedExcavation.models.length + ')'">
      <div class="button">
        <div>{{ 'iaa.app.excavation.models' | translate }} ({{ selectedExcavation.models.length }})</div>
        <div class="icons">
          <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }" aria-hidden="true"></i>
          <i class="pi pi-angle-down icon-clicked" aria-hidden="true"></i>
        </div>
      </div>
    </summary>

    <!-- Unauthorized Content Warning -->
    <div *ngIf="hasUnauthorizedContentForType('models')"
      role="alert"
      [ngClass]="{'unauthorized':true,'en': currentLang === 'en','he': currentLang === 'he'}">
      <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="" role="presentation">
      <div
        [ngClass]="{'unauthorized-text':true,'en': currentLang === 'en','he': currentLang === 'he'}">
        {{ 'iaa.app.results.licensesNotDisplayed' | translate:
        {numberOfAllEntitiesUnauthorized: getUnauthorizedCountForType('models')} }}
        <button class="unauthorized-link" 
          (click)="handleOpenDialog()"
          (keydown.enter)="handleOpenDialog()" 
          (keydown.space)="handleOpenDialog(); $event.preventDefault()"
          tabindex="0"
          [attr.aria-label]="'iaa.app.results.viewListLicenses' | translate">
          <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
        </button>
      </div>
    </div>

    <div class="table-container" role="table" [attr.aria-label]="'iaa.app.excavation.models' | translate">
      <div class="table-row header" role="row">
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.model' | translate }}</div>
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.licenseNumber' | translate }}</div>
        <div class="table-cell" aria-hidden="true"></div>
      </div>
      <div *ngFor="let model of selectedExcavation.models" class="table-row" role="row">
        <div class="table-cell" role="cell">
          <span class="link-note"
            *ngIf="model.entityId"
            (click)="navigateToModel(model)"
            (keydown.enter)="navigateToModel(model)"
            (keydown.space)="navigateToModel(model); $event.preventDefault()"
            tabindex="0"
            role="button"
            [attr.aria-label]="'View ' + ((model.modelName || {hebrew: '', english: ''}) | translateLang | async)">
            {{ (model.modelName || {hebrew: '', english: ''}) | translateLang | async }}
          </span>
          <span *ngIf="!model.entityId">{{ (model.modelName || {hebrew: '', english: ''}) | translateLang | async }}</span>
        </div>
        <div class="table-cell" role="cell">{{ model.licenseNumber }}</div>
        <div class="table-cell" aria-hidden="true">
          <div class="icon-container">
            <i class="pi pi-eye action-icon"
               *ngIf="model.entityId"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.view' | translate"
               (click)="navigateToModel(model)"
               (keydown.enter)="navigateToModel(model)"
               (keydown.space)="navigateToModel(model); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.view' | translate }}"></i>
            <i class="pi pi-download action-icon" 
               *ngIf="model.downloadUrl"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.download' | translate"
               (click)="openUrl(model.downloadUrl)"
               (keydown.enter)="openUrl(model.downloadUrl)"
               (keydown.space)="openUrl(model.downloadUrl); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.download' | translate }}"></i>
            <i class="pi pi-map-marker action-icon" 
               [ngClass]="{'active': model.entityId === selectedEntityId}"
               *ngIf="model.shapes && model.shapes.length > 0"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.showOnMap' | translate"
               (click)="onMapIconClick(model.entityId, 'model', $event)"
               (keydown.enter)="onMapIconClick(model.entityId, 'model', $event)"
               (keydown.space)="onMapIconClick(model.entityId, 'model', $event); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.showOnMap' | translate }}"></i>
          </div>
        </div>
      </div>
    </div>
  </details>

  <!-- Yazam Reports Section -->
  <details [open]="selectedExcavation.yazamReports.length === 1" *ngIf="selectedExcavation.yazamReports && selectedExcavation.yazamReports.length > 0">
    <summary
      [attr.aria-label]="('iaa.app.excavation.yazamReports' | translate) + ' (' + selectedExcavation.yazamReports.length + ')'">
      <div class="button">
        <div>{{ 'iaa.app.excavation.yazamReports' | translate }} ({{ selectedExcavation.yazamReports.length }})</div>
        <div class="icons">
          <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }" aria-hidden="true"></i>
          <i class="pi pi-angle-down icon-clicked" aria-hidden="true"></i>
        </div>
      </div>
    </summary>

    <!-- Unauthorized Content Warning -->
    <div *ngIf="hasUnauthorizedContentForType('reports')"
      role="alert"
      [ngClass]="{'unauthorized':true,'en': currentLang === 'en','he': currentLang === 'he'}">
      <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="" role="presentation">
      <div
        [ngClass]="{'unauthorized-text':true,'en': currentLang === 'en','he': currentLang === 'he'}">
        {{ 'iaa.app.results.licensesNotDisplayed' | translate:
        {numberOfAllEntitiesUnauthorized: getUnauthorizedCountForType('reports')} }}
        <button class="unauthorized-link" 
          (click)="handleOpenDialog()"
          (keydown.enter)="handleOpenDialog()" 
          (keydown.space)="handleOpenDialog(); $event.preventDefault()"
          tabindex="0"
          [attr.aria-label]="'iaa.app.results.viewListLicenses' | translate">
          <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
        </button>
      </div>
    </div>

    <div class="table-container" role="table" [attr.aria-label]="'iaa.app.excavation.yazamReports' | translate">
      <div class="table-row header" role="row">
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.report' | translate }}</div>
        <div class="table-cell" role="columnheader">{{ 'iaa.app.excavation.licenseNumber' | translate }}</div>
        <div class="table-cell" aria-hidden="true"></div>
      </div>
      <div *ngFor="let report of selectedExcavation.yazamReports" class="table-row" role="row">
        <div class="table-cell" role="cell">
          <span class="link-note" 
            *ngIf="report.viewUrl" 
            (click)="openUrl(report.viewUrl)" 
            (keydown.enter)="openUrl(report.viewUrl)" 
            (keydown.space)="openUrl(report.viewUrl); $event.preventDefault()"
            tabindex="0" 
            role="button"
            [attr.aria-label]="'View ' + ((report.reportTitle || {hebrew: '', english: ''}) | translateLang | async)">
            {{ (report.reportTitle || {hebrew: '', english: ''}) | translateLang | async }}
          </span>
          <span *ngIf="!report.viewUrl">{{ (report.reportTitle || {hebrew: '', english: ''}) | translateLang | async }}</span>
        </div>
        <div class="table-cell" role="cell">{{ report.licenseNumber }}</div>
        <div class="table-cell" aria-hidden="true">
          <div class="icon-container">
            <i class="pi pi-eye action-icon" 
               *ngIf="report.viewUrl"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.view' | translate"
               (click)="openUrl(report.viewUrl)"
               (keydown.enter)="openUrl(report.viewUrl)"
               (keydown.space)="openUrl(report.viewUrl); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.view' | translate }}"></i>
            <i class="pi pi-map-marker action-icon" 
               [ngClass]="{'active': report.entityId === selectedEntityId}"
               *ngIf="report.shapes && report.shapes.length > 0"
               role="button"
               tabindex="0"
               [attr.aria-label]="'iaa.app.excavation.showOnMap' | translate"
               (click)="onMapIconClick(report.entityId, 'report', $event)"
               (keydown.enter)="onMapIconClick(report.entityId, 'report', $event)"
               (keydown.space)="onMapIconClick(report.entityId, 'report', $event); $event.preventDefault()"
               title="{{ 'iaa.app.excavation.showOnMap' | translate }}"></i>
          </div>
        </div>
      </div>
    </div>
  </details>

    </div><!-- End details-wrapper -->

    <!-- Images Section (Orthophotos) -->
    <app-image-gallery 
      *ngIf="excavationImages?.length" 
      [thumbnails]="excavationImageThumbnails" 
      [images]="excavationImages" 
      [objectName]="getExcavationName()"
      class="gallery"/>
  </div><!-- End main-content-container -->

  <!-- Unauthorized Dialog -->
  <app-unauthorized-dialog
    [unauthorizedLicenses]="processedUnauthorizedLicenses"
    [isOpen]="isUnauthorizedDialogOpen"
    [currentLanguage]="currentLang"
    (onClose)="handleCloseDialog()">
  </app-unauthorized-dialog>
</div>
